import { Component, OnInit } from "@angular/core"
import { Title } from "@angular/platform-browser"
import { UserService } from "../../services/user.service"
import { PBSLM_TITLE } from "../../models/constants"
import { GTMService } from "../../services/gtm.service"

declare var window: any

@Component({
    templateUrl: "./assignment-results-proxy.component.html",
    styleUrls: ["../error.component.less"],
})
export class AssignmentResultsProxyComponent implements OnInit {
    public imageURL: string = null
    public assignmentName: string = null
    public nextURL: string = "/"

    constructor(
        public userService: UserService,
        private gtmService: GTMService,
        private titleService: Title
    ) {
        this.imageURL = require("../../../assets/401error.png").default
    }

    ngOnInit() {
        this.loadWindowData()
        this.nextURL = window.location.pathname
        this.gtmService.resetDataLayer()
        this.gtmService.pushPageView()
    }

    private loadWindowData() {
        let data = (window.PBSLM.NG || {}).CUSTOM_DATA.assignment_results_proxy
        if (!data) {
            return
        }
        this.imageURL = data.poster_url || this.imageURL
        this.assignmentName = data.name
        if (data.name) {
            this.titleService.setTitle(`${data.name} | ${PBSLM_TITLE}`)
        } else {
            this.titleService.setTitle(`${PBSLM_TITLE}`)
        }
    }
}
